// extracted by mini-css-extract-plugin
module.exports = {"skewed_btn_wrapper":"SkewedButton-module--skewed_btn_wrapper--2JuG-","smaller_skew":"SkewedButton-module--smaller_skew--1yqbC"};